import { render, staticRenderFns } from "./InvitationExpansionPanel.vue?vue&type=template&id=27ae5f50"
import script from "./InvitationExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./InvitationExpansionPanel.vue?vue&type=script&lang=ts"
import style0 from "./InvitationExpansionPanel.vue?vue&type=style&index=0&id=27ae5f50&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports